import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import CssBaseline from "@material-ui/core/CssBaseline";
import Menu from "./common/menu";
import CustomLoader from "./common/loader";
import ErrorSnackbar from "./common/errorSnackbar";
import { loadUserData } from "../reducers/auth/session";

const Auth = (props) => {
  const { component, loading, loadUserData, session, isPermitted=true, ...rest } = props;
  const { token } = window.localStorage;

  useEffect(() => {
    if (token) {
      loadUserData();
    }
  }, []);

  return (
    <div>
      <CssBaseline />
      <Menu>
        <ErrorSnackbar>
          {loading ? (
            <CustomLoader />
          ) : token && isPermitted ? (
            <Route {...rest} render={component} />
          ) : (
            <Redirect to={"/"} />
          )}
        </ErrorSnackbar>
      </Menu>
    </div>
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
  loading: state.session.loading,
});

const mapDispatchToProps = (dispatch) => ({
  loadUserData: () => dispatch(loadUserData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
